import React from "react";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Moment from 'moment';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import HolidayRequestDetailsNode from '../customNodes/HolidayRequestDetailsNode';
import EmployeeSelection from '../customNodes/EmployeeSelection';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import {
    changeholidaystatus, myData, saveverlofaanvraag,updateHolidayRequest
} from "../dbconnector/connector";
import { CgCloseR } from "react-icons/cg";

const HolidayRequestNode = ({ rights, t, isDisabled, data, events, css }) => {
    const [key, setKey] = useState('home');
    const [user, setUser] = useState({});
    const [approver, setapprover]= useState();

    useEffect(() => {
        getMyData()
        if(rights === 3)
        {
            document.getElementById("approved").style.display = "none"
        }else
        {
            document.getElementById("approved").style.display = "block"
        }
        if (data.record.approved_by !== undefined || data.record.approved_by !== null)
        {
            setapprover(data.record.approved_by) 
        }
        else
        {
            setapprover(user.id) 
        }
    }, [data]);

    const getMyData = async () => {
        myData().then(res => {
          if (res) {
            setUser({ ...res })
          }
        })
      }


    const updaterequest = (e) => {
        let afkeurreden = document.getElementById("reden_afkeur").value
        let status = document.getElementById("status").value
        let datum  = Moment().toLocaleString('en-CA')
        data.record.approved_by = user.id;
        data.record.approvaldate = datum;
        delete data.record.email;
        delete data.record.voornaam;
        //delete data.record.startdatum;
        //delete data.record.einddatum;
        delete data.record.achternaam;
        delete data.record.hotel_Id;
        //console.log("data", data)
        updateHolidayRequest(data.record.id, data.record).then((result) => {
            if (result.status === 200) {
                events.LoadRequests()
                events.handleCancel()
            } else {
                setErrorMessage(result.status + ": " + result.statusText)
            }

        })
    }

    return (
        <>
            <div id="assignmentdetails" className='Holidaydiv'>
                <div className='formcaption'>{t('DetailsHolidayRequest')}
                    <CgCloseR className='closer' onClick={events.handleCancel} />
                </div>
                <div className="AssignHolidayRequestform">
                    <HolidayRequestDetailsNode
                      rights={rights}
                      t={t}
                      isDisabled={true}
                      data={data }
                      events={events}
                      css={hotelcss}
                    />
                    {/* <div id="AdminApproval" className="holidaydetails noborder noscroll"> */}
                        <div className="holidaydetails groupbox_holiday DarkGreenborder">
                            <label className='formtitleGroupBox_lightgreen'>{t('ApprovalDetails')}
                            </label>
                            <label className="spacer"></label><label className="spacer"></label>
                            <label className='labelhotel'>{t('Status')}</label>
                            <select className='date2' defaultValue="0" id="status" name="status" value={data.record.status} onChange={events.handleitemchange}  disabled={isDisabled}>
                                <option value="0">{t('requested')}</option>
                                <option value="1">{t('pre-approved')}</option>
                                <option value="2" id="approved" disabled={rights===2?false:true}> {t('approved')}</option>
                                <option value="3">{t('rejected')}</option>
                            </select>
                            <label className='labelhotel' >{t('Redenafkeur')}</label>
                            <textarea id="reden_afkeur" name="reden_afkeur" className="textareaReason2" value={data.record.reden_afkeur !== null ? data.record.reden_afkeur : ""}  onChange={events.handleitemchange} disabled={isDisabled}></textarea>
                            <label className='labelhotel'>{t('Approver')}</label>
                            <EmployeeSelection  className='date2'  isDisabled={true} data={{ disabled: true, fieldname: "approved_by", selectedemployee: approver, handleitemchange: null }} valueneeded="approved_by" cssclass="date2"  />
                            <label className='labelhotel'>{t('ApprovalDate')}</label>
                            <input type="date" id="start" name="approvaldate" value={data.record.approvaldate !== null? Moment(data.record.approvaldate).format('yyyy-MM-DD'):Moment().format('yyyy-MM-DD')} className='date2' disabled />
                             <p></p>
                            <Button id="saveButton" type="submit" className='Savebutton' style={isDisabled === true ? { display: "none" } : { display: "block" }} onClick={updaterequest}>{t('Save')}</Button>
                        </div>
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}


export default HolidayRequestNode;
